import authentication from '@/modules/authentication/api/authentication';

// initial state
const state = {
    authentication: JSON.parse(localStorage.getItem('auth')) || {
        isAuthenticated: false,
        token: null,
    },
};

// getters
const getters = {
    isAuthenticated: s =>
    {
        return s.authentication.isAuthenticated;
    },
};

// actions
const actions = {
    authenticate({commit}, credentials)
    {
        return new Promise((resolve, reject) =>
        {
            commit('setAuthenticationStatus', null);

            authentication.authenticate(
                credentials.username,
                credentials.password,
                token =>
                {
                    commit('setAuthenticationStatus', true);
                    commit('setToken', token);

                    resolve();
                },
                () =>
                {
                    commit('setAuthenticationStatus', false);

                    reject();
                }
            );
        });
    },
    logout({commit})
    {
        return new Promise((resolve) =>
        {
            commit('logout');
            resolve();
        });
    },
};

// mutations
const mutations = {
    setAuthenticationStatus(s, status)
    {
        s.authentication.isAuthenticated = status;

        localStorage.setItem('auth', JSON.stringify(s.authentication));
    },

    setToken(s, token)
    {
        s.authentication.token = token;

        localStorage.setItem('auth', JSON.stringify(s.authentication));
    },

    logout(s)
    {
        s.authentication.isAuthenticated = false;
        s.authentication.token = null;

        localStorage.setItem('auth', JSON.stringify(s.authentication));
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
